import { Crown, CheckCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function EnterpriseGateModal({ open, onOpenChange, featureName }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl border border-gray-200 shadow-2xl bg-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-bold text-base flex items-center gap-2">
            <Crown size={18} className="text-amber-500" /> Fonction Entreprise
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-500">
            <span className="font-semibold text-gray-700">{featureName}</span> est disponible uniquement avec la licence Entreprise.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-3 bg-gray-900 rounded-xl p-5 text-white">
          <div className="flex items-baseline gap-1 mb-3">
            <span className="text-3xl font-bold">49</span>
            <span className="text-sm text-gray-400">EUR / mois</span>
          </div>
          <ul className="space-y-2 mb-4">
            {["Diagrammes illimités", "Assistant IA vocal", "Export PDF & Cahier des charges", "Review client & Portail", "Voix off TTS & Video", "Gestion acces & clés API"].map(f => (
              <li key={f} className="flex items-center gap-2 text-xs text-gray-300"><CheckCircle size={11} className="text-amber-400 shrink-0" /> {f}</li>
            ))}
          </ul>
          <button
            onClick={() => { onOpenChange(false); window.open("/#pricing", "_blank"); }}
            className="w-full py-2.5 rounded-lg text-sm font-bold bg-white text-gray-900 hover:bg-gray-100 transition-colors"
            data-testid="upgrade-enterprise-cta"
          >
            Passer Entreprise
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
